export const GET_USERDETAILS = "GET_USERDETAILS";
export const SET_USERDETAILS = "SET_USERDETAILS";
